<ngx-spinner  bdColor="rgba(128, 128, 128, 0.8)"
              size="default"
              color="#2f9cf2"
              type="line-scale-pulse-out"
              [name]="spinnerName"
              [fullScreen]="false"><p style="color:white">{{spinnerText}}</p></ngx-spinner>
<p-toast position="top-right"></p-toast>

<p-toolbar>
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>

    <span style="padding-top:1px;">
      <button (click)="refresh()"
              pButton type="button" 
              class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
              title="Refresh current roster"
              icon="pi pi-fw pi-refresh"></button>             
      <!-- Display only on bigger than md screens-->
      <span class="p-d-none p-d-md-inline">
        <button pButton
                label="Load Roster" 
                class="p-button p-button-text" 
                icon="fas fa-cloud-download-alt" 
                type="button" 
                (click)="loadRosterData()"></button>

        <button pButton type="button" *ngIf="canExportRoster()"
                label="Excel Report" 
                class="p-button p-button-text"
                icon="{{exportingRoster ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fa fa-file-excel-o fa-lg text-success'}}"
                [disabled]="exportingRoster"
                (click)="exportRoster()"></button>

        <button pButton *ngIf="canGenerateSignOnSheet()"
                label="Signon Sheet" 
                class="p-button p-button-text" 
                icon="{{generatingSignOnSheet ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'fa fa-file-pdf-o fa-lg text-danger'}}"
                type="button" 
                (click)="generateDailySignonSheet()"></button>

        <button pButton *ngIf="canModifyRoster()"
                label="Update Travel Status" 
                class="p-button p-button-text" 
                icon="{{updatingTravelStatus ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-plane'}}"
                type="button" 
                [disabled]="selectedEmployee === null"
                title="Select an employee from roster to update the travel status"
                (click)="updateTravelStatus()"></button>

        <button pButton pRipple *ngIf="canModifyRoster()"
                label="Generate Roster Data" 
                class="p-button p-button-text" 
                icon="fas fa-tasks" 
                type="button" 
                (click)="generateRosterData()"></button>
    
        <button pButton pRipple *ngIf="canModifyRoster() && isActiveRoster"
                label="Fix Payroll Roster Code" 
                class="p-button p-button-text" 
                icon="fas fa-hammer" 
                type="button" 
                (click)="fixPayrollRosterCode()"></button>

        <button pButton pRipple *ngIf="canModifyRoster()"
                label="Delete Future Roster Data" 
                class="p-button p-button-text" 
                icon="far fa-calendar-times" 
                type="button" 
                (click)="deleteFutureRosterData()"></button>                
    
      </span>

      <!-- Display only on smaller than md screens-->
      <span class="p-d-md-none">
        <button pButton pRipple
                class="p-button-rounded p-button-success"
                icon="pi-fw fas fa-cloud-download-alt" 
                type="button" 
                (click)="loadRosterData()"></button>

        <button pButton pRipple *ngIf="canExportRoster()"
                class="p-button-rounded p-button-success"
                icon="{{exportingRoster ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fa fa-file-excel-o text-success-light'}}"
                [disabled]="exportingRoster"
                type="button" 
                (click)="exportRoster()"></button>

        <button pButton pRipple *ngIf="canGenerateSignOnSheet()"
                class="p-button-rounded p-button-success" 
                icon="{{generatingSignOnSheet ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fa fa-file-pdf-o text-danger'}}"
                type="button" 
                (click)="generateDailySignonSheet()"></button>

        <button pButton pRipple *ngIf="canModifyRoster()"
                class="p-button-rounded p-button-success" 
                icon="{{updatingTravelStatus ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-plane'}}"
                [disabled]="selectedEmployee === null"
                type="button" 
                (click)="updateTravelStatus()"></button>

        <button pButton pRipple *ngIf="canModifyRoster()"
                class="p-button-rounded p-button-success" 
                icon="pi-fw fas fa-tasks" 
                type="button" 
                (click)="generateRosterData()"></button>
    
        <button pButton pRipple *ngIf="canModifyRoster() && isActiveRoster"
                class="p-button-rounded p-button-success" 
                icon="pi-fw fas fa-hammer" 
                type="button" 
                (click)="fixPayrollRosterCode()"></button>

        <button pButton pRipple *ngIf="canModifyRoster() && isActiveRoster"
                class="p-button-rounded p-button-success" 
                icon="far fa-calendar-times" 
                type="button" 
                (click)="deleteFutureRosterData()"></button>                
      </span>
    </span>
  </div>

  <div class="p-toolbar-group-right">
    <p-multiSelect [options]="summaryLineData"
                    class="p-inputtext-sm p-mr-2 show-hide" 
                    name="summaryLineData"
                    appendTo="body"
                    [showHeader]="false"
                    [filter]="false"
                    [showToggleAll]="false"
                    inputId="summaryLineData" 
                    optionLabel="title"
                    dataKey="title"
                    [maxSelectedLabels]="1"
                    [displaySelectedLabel]="false"
                    dropdownIcon="fas fa-eye fa-2x"
                    scrollHeight="270px"
                    placeholder="&nbsp;"
                    emptyMessage="No summary line defined."
                    [disabled]="summaryLineData.length === 0"
                    title="Show/hide summary line"
                    (onChange)="showHideSummaryLine()"
                    [(ngModel)]="pinnedSummaryLineData">
    </p-multiSelect>
    
    <p-multiSelect [options]="employeeColumns"
                    class="p-inputtext-sm p-mr-2 show-hide" 
                    name="employeeColumns"
                    appendTo="body"
                    [showHeader]="false"
                    [filter]="false"
                    [showToggleAll]="false"
                    inputId="employeeColumns" 
                    optionLabel="columnName"
                    dataKey="colId"
                    [maxSelectedLabels]="1"
                    [displaySelectedLabel]="false"
                    dropdownIcon="fa fa-eye fa-2x"
                    scrollHeight="300px"
                    selectedItemsLabel="{0} columns"
                    placeholder="&nbsp;"
                    title="Show/hide employee columns"
                    (onChange)="showHideEmployeeColumns()"
                    [(ngModel)]="selectedEmployeeColumns">
    </p-multiSelect>
  </div>  
</p-toolbar>

<div *ngIf="this.employeeRosters.length > 0" class="m-1 pps-roster" [style]="{height: 'calc(100% - 36px)'}">
  <ag-grid-angular  style="width: 100%; height: 100%;"
                    class="ag-theme-alpine pps-roster"
                    [rowData]="employeeRosters"
                    [columnDefs]="gridHeaders"
                    [gridOptions]="gridOptions"
                    rowSelection="single"
                    (cellKeyDown)="onCellKeyPress($event)"
                    (cellDoubleClicked)="onCellDoubleClicked($event)"
                    [pinnedBottomRowData]="pinnedSummaryLineData"
                    [tooltipShowDelay]="tooltipShowDelay"
                    [tooltipMouseTrack]="true"
                    [components]="frameworkComponents"
                    [rowDragManaged]="false"
                    (rowDragMove)="onRowDragMove($event)"
                    (sortChanged)="onSortChanged($event)"
                    (filterChanged)="onFilterChanged($event)"    
                    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div>
<p-confirmDialog key="invalidPayrollRosterCodePromptDialog1"></p-confirmDialog>
<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="Y" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog #red_cd [style]="{width: '600px'}" [styleClass]="'red-header'" key="danger-dialog">
  <p-footer>
    <button type="button" pButton accesskey="Y" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="red_cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="red_cd.reject()"></button>
  </p-footer>
</p-confirmDialog>


<p-sidebar  [(visible)]="showEmptyPayrollRosterCode" position="right" [baseZIndex]="10000" 
            [showCloseIcon]="true" [dismissible]="false" [modal]="false"
            class="empty-payroll-roster-code-container p-component">
  <ng-template pTemplate="header">
    <h2>Fix Payroll Roster Code</h2>
  </ng-template>            
  <pps-invalid-employee-roster *ngIf="showEmptyPayrollRosterCode" 
    [from]="startDate" 
    [to]="endDate"
    [rosterProjectId]="rosterProject.id"
    (onSelect)="focusOnInvalidPayrollRosterCodeCell($event)"
    (onReloadRoster)="refresh()"
    ></pps-invalid-employee-roster>  
</p-sidebar>
